var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c-56.6 0-102.4 45.8-102.4 102.4s45.8 102.4 102.4 102.4c56.6 0 102.4-45.8 102.4-102.4s-45.8-102.4-102.4-102.4zM512 409.6c-56.6 0-102.4 45.8-102.4 102.4 0 56.602 45.8 102.4 102.4 102.4s102.4-45.798 102.4-102.4c0-56.6-45.8-102.4-102.4-102.4zM409.6 921.6c0-56.602 45.8-102.4 102.4-102.4s102.4 45.798 102.4 102.4c0 56.602-45.8 102.4-102.4 102.4s-102.4-45.798-102.4-102.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVertical);
export default __webpack_public_path__ + "static/media/menu-vertical.d39a43d1c3df175fbc5454186647dd6a.svg";
export { ForwardRef as ReactComponent };